<template>
  <div id="divSnackbar">

    <!--
    <v-btn color="red" text
      @click="mockSnackbarError">Mock Snackbar Error</v-btn>
    <v-btn color="green" text
      @click="mockSnackbarSuccess">Mock Snackbar Success</v-btn>
    <v-btn color="primary" text
      @click="mockSnackbarInfo">Mock Snackbar Info</v-btn>
    -->
    <v-snackbar
      v-model="snackbar"
      :timeout="snackbarTimeout"
      :color="color"
    >
      {{ error }}
      <template v-slot:action="{ attrs }">
        <v-btn
          color="primary"
          text v-bind="attrs"
          @click="clearSnackbar"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  name: 'Snackbar',

  components: {
  },

  data: () => ({
    errorTimeout: 5200, // ms
    maxTimeout: 30000, // ms
    msPerChar: 70, // reading time, so long messages stay up long enough to read
  }),
  computed: {
    snackbarTimeout() {
      const readingTime = String(this.error || '').length * this.msPerChar;
      return Math.min(Math.max(this.errorTimeout, readingTime), this.maxTimeout);
    },
    error: {
      set(error) {
        this.$store.dispatch('flashError', error);
      },
      get() {
        return this.$store.state.error;
      },
    },
    snackbar: {
      set(value) {
        this.$store.commit('setSnackbar', value);
      },
      get() {
        return this.$store.state.snackbar;
      },
    },
    color: {
      get() {
        return this.$store.state.snackbarColor;
      },
    },
  },
  methods: {
    clearSnackbar() {
      this.$store.dispatch('clearSnackbar');
    },
    mockSnackbarError() {
      this.$store.dispatch('flashError', 'this is a test!');
    },
    mockSnackbarSuccess() {
      this.$store.dispatch('flashSuccess', 'this is a test! this is a test! this is a test!');
    },
    mockSnackbarInfo() {
      this.$store.dispatch('flashInfo', 'this is a normal test!');
    },
  },
};
</script>
